import React from 'react';

export const Arrow = () => (
    <svg
        version="1.2"
        baseProfile="tiny-ps"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27 15"
        width="27"
        height="15">
        <title>1</title>
        <g id="1">
            <g id="PRZELEW">
                <path
                    id="ARROW"
                    className="shp0"
                    fill="#fff"
                    d="M1.46 8.63C-0.13 8.71 -0.25 6.32 1.4 6.23L22.44 6.23L18.5 2.3C17.73 1.55 18.25 0.24 19.33 0.24C19.65 0.24 19.96 0.37 20.19 0.6L26.16 6.59C26.62 7.05 26.62 7.81 26.16 8.27L23.77 10.67L20.19 14.26C19.06 15.39 17.37 13.7 18.5 12.56L22.43 8.63L1.46 8.63L1.46 8.63ZM1.46 8.63"/>
            </g>
        </g>
    </svg>
)